import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import { RightSvg } from "@/assets/icons";
import { useCommonStore } from "@/stores";
import { ExpTemp } from "@/components";
import { useExpTempList } from "@/hooks";
import { ExpTempType } from "@/constants";
import { ExpTempUploader } from "@/components";
import clsx from "clsx";

const ChooseExpTemp = () => {
  const { t } = useTranslation();
  const activeExpTempIndex = useCommonStore(state => state.activeExpTempIndex);
  const activeExpTempType = useCommonStore(state => state.activeExpTempType);
  const communityExpTempList = useCommonStore(state => state.communityExpTempList);
  const presetExpTempList = useCommonStore(state => state.presetExpTempList);
  const cusExpTempList = useCommonStore(state => state.cusExpTempList);
  const moreExpTempVisible = useCommonStore(state => state.moreExpTempVisible);
  const setMoreExpTempVisible = useCommonStore(state => state.setMoreExpTempVisible);
  const updatePlayState = useCommonStore(state => state.updatePlayState);
  const {
    handleClickCommunityExpTemp,
    handleClickPresetExpTemp,
    handleClickCusExpTemp,
  } = useExpTempList();

  const handleMore = () => {
    setMoreExpTempVisible(true);
    updatePlayState(false);
  }

  return (
    <div
      className={styles["choose_exp_temp"]}
    >
      <div
        className={styles["header"]}
      >
        <span
          className={clsx(
            styles["title"], 
            "ellipsis"
          )}
        >
          {t("choose_exp_temp_title")}
        </span>

        <button
          className={styles["more_button"]}
          onClick={handleMore}
        >
          <span>{t("more_exp_temp_button")}</span>
          <RightSvg></RightSvg>
        </button>
      </div>

      <div
        className={styles["exp_temp_list"]}
      >
        {communityExpTempList.map((item, index) => (
          <div
            className={styles["exp_temp_wrapper"]}
            key={item.id}
          >
            <ExpTemp
              {...item}
              active={activeExpTempType === ExpTempType.Community && activeExpTempIndex === index}
              isPlay={moreExpTempVisible ? false : item.isPlay}
              onClick={() => handleClickCommunityExpTemp(index, item)}
              expTempType={ExpTempType.Community}
            ></ExpTemp>
          </div>
        ))}

        {presetExpTempList.slice(0, 4).map((item, index) => (
          <div
            className={styles["exp_temp_wrapper"]}
            key={item.id}
          >
            <ExpTemp
              {...item}
              active={activeExpTempType === ExpTempType.Preset && activeExpTempIndex === index}
              isPlay={moreExpTempVisible ? false : item.isPlay}
              onClick={() => handleClickPresetExpTemp(index, item)}
            ></ExpTemp>
          </div>
        ))}

        {cusExpTempList.map((item, index) => (
          <div
            className={styles["exp_temp_wrapper"]}
            key={item.id}
          >
            <ExpTemp
              {...item}
              active={activeExpTempType === ExpTempType.Cus && activeExpTempIndex === index}
              isPlay={moreExpTempVisible ? false : item.isPlay}
              onClick={() => handleClickCusExpTemp(index, item)}
            ></ExpTemp>
          </div>
        ))}

        <div
          className={styles["exp_temp_wrapper"]}
        >
          <ExpTempUploader></ExpTempUploader>
        </div>
      </div>
    </div>
  )
}

export default ChooseExpTemp;